/* ===========================================================================
 * WHICH SETTINGS THE ADMIN PIN STANDS IN FRONT OF, AND WHICH IT NO LONGER DOES.
 *
 * It used to be all of them. `AdminLockGate` wrapped `/settings`, every
 * `/settings/g/:group` and the device register, so a tenant that set an admin
 * PIN put a second full-screen keypad in front of the leave calendar, the
 * letter wording and the company address — none of which is what the PIN is
 * for. The owner: "i want this for apk and system settings not for everything".
 *
 * THE THREE THAT STAY, and each one is a capability rather than a preference:
 *   security  the password rules, the session timeout, and the KIOSK LOCK CARD
 *             — the admin PIN itself. This one is not a judgement call: leave
 *             it open and anybody who reaches Settings can clear the PIN and
 *             the whole layer is decoration. A lock whose key is behind the
 *             lock is the only shape that holds.
 *   modules   which parts of the app exist for this company. A switch here
 *             removes a surface from every user at once.
 *   erp       where payroll is pushed and with whose credentials.
 * The device register is gated too, in `App.tsx` rather than here, because it
 * is a route rather than a settings group — it is where a tablet is registered,
 * revoked and wiped, which is this console's own authentication surface.
 *
 * WHAT IS OPEN NOW: pay rules, attendance, time off, notifications, letters,
 * company, and the managed-elsewhere index. Every one of them is already behind
 * the login AND the ADMIN/HR role check, and none of them changes who can get
 * in. Pay rules change what a day is WORTH, which is a different kind of
 * serious and has its own confirm-and-diff flow rather than a keypad.
 *
 * ONE LIST, READ TWICE — the route decides whether to draw the pad, and the
 * settings page decides whether a SEARCH may reach into a group. A second copy
 * of this set is the defect where a group is gated on its own URL and readable
 * from the search box.
 * ======================================================================== */

/** Settings groups that stay behind the admin PIN. */
export const ADMIN_LOCKED_GROUPS: ReadonlySet<string> = new Set([
  'security',
  'modules',
  'erp',
]);

/** Whether `?group=` / `:group` names one of them. */
export function isAdminLockedGroup(group: string | undefined | null): boolean {
  return group !== undefined && group !== null && ADMIN_LOCKED_GROUPS.has(group);
}
